/**
 * Import required libraries
 */
import React, { useEffect, useRef, useMemo } from "react";
import { Provider, connect } from "react-redux";
import { ThemeProvider, useTheme } from "@material-ui/core";

/**
 * Import required elements
 */
import store from "./store";
import setTheme from "../utils/theme"

const customFont = ["Bahnschrift Condensed"]

/**
 * AppThemeProvider Component
 */
let AppThemeProvider = props => {
  let { data, form } = props;

  const theme = useTheme();
  const themeRef = useRef(theme)
  themeRef.current = theme

  window.materialTheme = useMemo(() => setTheme(themeRef.current, data, form), [data, form]);

  useEffect(() => {
    if (data.selectedTypos && !customFont.includes(data.selectedTypos)) {
      let link = document.querySelector("#googleFont") || document.createElement('link');
      link.id = "googleFont";
      link.rel = 'stylesheet';
      let officialName = data.selectedTypos.replace(" ", "+")
      let ref = "https://fonts.googleapis.com/css2?family=" + officialName + "&display=swap"
      link.href = ref;
      document.getElementsByTagName('head')[0].appendChild(link);
    } else {
      if (data.selectedTypos === "Bahnschrift Condensed") {
        console.log("verif")
        let link = document.querySelector("#googleFont") || document.createElement('link');
        link.type = "text/css"
        link.rel = "stylesheet"
        link.href = "//db.onlinewebfonts.com/c/0a6ee448d1bd65c56f6cf256a7c6f20a?family=Bahnschrift"
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    }
  }, [data.selectedTypos])

  return (
    <ThemeProvider theme={window.materialTheme}>{props.children}</ThemeProvider>
  );
};

AppThemeProvider = connect(state => ({
  data: (state.simtopy.selectedTheme && state.list.theme[state.simtopy.selectedTheme]) || state.locale.initTheme,
  form: state.forms.themeForm
}))(AppThemeProvider);

/**
 * SimtopyProvider Component
 */
function SimtopyProvider(props) {
  window.store = store;
  return (
    <Provider store={window.store}>
      <AppThemeProvider>{props.children}</AppThemeProvider>
    </Provider>
  );
}

export { store }

export default SimtopyProvider;
